import { render } from "./MultiStepIndicator.vue?vue&type=template&id=3524d596&scoped=true"
import script from "./MultiStepIndicator.vue?vue&type=script&lang=js"
export * from "./MultiStepIndicator.vue?vue&type=script&lang=js"

import "./MultiStepIndicator.vue?vue&type=style&index=0&id=3524d596&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3524d596"]])

export default __exports__